import React, { useState, useEffect } from 'react';
import PerinHealthGrid from '../../components/PerinHealthGrid';
import { setSelectAll, setSelectedItem, setSelectedRows } from '../../components/PerinHealthGridSlice';
import { resetFilterState } from '../../slicers/FilterSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useAxios from '../../services/AxiosConfig';
import FilterManagementView from '../../components/FilterManagementView';
import { closeModal } from '../../components/PerinHealthModelSlice';
import managementStyles from '../ManagementPages.module.css';
import { showAlert } from '../../components/PerinHealthAlertSlice';
import { setRegistryData, resetTabletState, setUpdatingTablet } from './TabletSlice';


const TabletManagement = () => {
    const dispatch = useDispatch();
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const httpService = useAxios(axiosConfig.envURL);
    const userDateFormat = useSelector((state) => state.userInfo.dateFormat);
    const tabletSlice = useSelector((state)=>state.tabletManagement);

    useEffect(() => {
        dispatch(resetFilterState());
        dispatch(setSelectedRows([]));
        dispatch(setSelectedItem({}));
        dispatch(resetTabletState());
    }, []);

    const navigate = useNavigate();
    const userId = useSelector((state) => state.userInfo.id);
    const perinHealthGrid = useSelector((state) => state.perinHealthGrid);
    let selectedRows = perinHealthGrid.selectedRows;

    const headers = [
        { key: 'groupName', label: 'Group'},
        { key: 'quantity', label: "Quantity"},
        { key: 'numAssigned', label: "Assigned"},
    ];

    const [tabletData, setTabletData] = useState([]);

    useEffect(() => {
        getTablets();
    }, []);

      
    const getTablets = async () => {
        dispatch(resetFilterState());
        httpService.get(`tablet/group/${userId}`)
        .then((responseData) => {
            if (Array.isArray(responseData.data.data)) {
                setTabletData(responseData.data.data);
            } else {
                console.error('Invalid data format:');
            }
        })
        .catch((err) => {
            console.log(err);
        });
    };

    const onAddTabletHandler = () => {
        navigate('/add-tablet');
    };

    const editGroupTabletHandler = (rowItem) => {
        dispatch(setUpdatingTablet(rowItem));
        navigate(`/add-tablet`);
    };

    const onRowValueClickHandler = (rowItem) => {
        dispatch(setRegistryData({
            "groupName":rowItem.groupName, 
            "totalTablets":rowItem.quantity,
            "groupId": rowItem.groupId,
            "tablets": rowItem.tablets
        }))
        navigate('/tablet-registry');
    };

    const onDeleteHandler = () => {
        const deletePromises = selectedRows.map((tablet) => {
            const id = tablet.id;
            return httpService.delete(`tablet/list/${id}`);
        });
    
        Promise.all(deletePromises)
            .then(() => {
                // Filter out the deleted roles from the roleData state
                const updatedTabletData = tabletData.filter(tablet => !selectedRows.some(row => row.id === tablet.id));
                setTabletData(updatedTabletData);
    
                dispatch(setSelectedRows([]));
                dispatch(setSelectAll(false));
                getTablets();
                dispatch(closeModal());
                dispatch(
                    showAlert({
                        header: "Success",
                        message: "Deleted tablets successfully",
                        type: 'success',
                    })
                );
            })
            .catch((errors) => {
                console.error('Error deleting roles:', errors);
                dispatch(
                    showAlert({
                        header: "Error",
                        message: "Error deleting roles",
                        type: 'danger',
                    })
                );
            });
    };

    return (
        <div className={managementStyles.MiddleContent}>
            <FilterManagementView
                isOrganization={true}
                isGroup={true}
                isSubGroup={false}
                isTeam={false}
                addButtonLabel='Add Tablet'
                onAddHandler={onAddTabletHandler}
                showDeleteButton={false}
            />
            <div className={managementStyles.GridContainer}>
                <PerinHealthGrid
                    dataList={tabletData}
                    headers={headers}
                    showCheckbox={false}
                    showEditIcon={true}
                    onRowClick={editGroupTabletHandler}
                    onRowValueClick={onRowValueClickHandler}
                    onDeleteRow={onDeleteHandler}
                    showHeaderFilter={true}
                    rowValueAction={'groupName'} 
                    gridHeight="100%"
                />
            </div>
        </div>
    );
};

export default TabletManagement;
